import { Box, type SxProps, type Theme } from '@mui/material';
import { type ReactNode } from 'react';

import { mergeSxProps } from '../../Mui/mergeSxProps';
import { STANDARD_LAYOUT_PADDING_X, STANDARD_LAYOUT_PADDING_Y } from '../constants.js';
import { type PaddingVariant } from '../types.js';

interface StandardPageBodyProps {
  /**
   * The content to display in the page.
   */
  children: ReactNode;
  /**
   * The padding around the content.
   * Use `None` for content that fills the page and manages its own edges.
   * @default 'Standard'
   */
  paddingVariant?: PaddingVariant;
  sx?: SxProps<Theme>;
}

export function StandardPageBody(props: StandardPageBodyProps) {
  const { children, paddingVariant = 'Standard', sx } = props;

  return (
    <Box
      {...(paddingVariant === 'None'
        ? { padding: 0 }
        : { paddingX: STANDARD_LAYOUT_PADDING_X, paddingY: STANDARD_LAYOUT_PADDING_Y })}
      sx={mergeSxProps({ overflowY: 'auto' }, sx)}
    >
      {children}
    </Box>
  );
}
